import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class MasterDataService {
  private masterDataSubject = new BehaviorSubject<any>(null);
  private storageKey = 'masterData';
  private selectedKey = 'masterData.selected';

  constructor() {
    // Load persisted data from localStorage when service is created
    const saved = localStorage.getItem(this.storageKey);
    if (saved) {
      try {
        this.masterDataSubject.next(JSON.parse(saved));
      } catch {
        // If JSON parse fails, clear it
        localStorage.removeItem(this.storageKey);
      }
    }
  }

  setMasterData(data: any): void {
    // Update BehaviorSubject
    this.masterDataSubject.next(data);
    // Persist to localStorage for reloads
    localStorage.setItem(this.storageKey, JSON.stringify(data));
    console.log('Master data set:', JSON.stringify(data));
  }

  // Selected IDs helpers: persist user's current selection so dropdowns can auto-select
  setSelectedIds(selected: { customerId?: number | null; siteId?: number | null; contractId?: number | null }) {
    try {
      const cur = JSON.parse(localStorage.getItem(this.selectedKey) || '{}');
      const next = { ...(cur || {}), ...(selected || {}) };
      localStorage.setItem(this.selectedKey, JSON.stringify(next));
    } catch (e) {
      localStorage.setItem(this.selectedKey, JSON.stringify(selected || {}));
    }
  }

  getSelectedIds(): { customerId?: number | null; siteId?: number | null; contractId?: number | null } {
    try {
      return JSON.parse(localStorage.getItem(this.selectedKey) || '{}') || {};
    } catch (e) {
      return {};
    }
  }

  getMasterData(): any {
    return this.masterDataSubject.value;
  }

  getMasterData$(): Observable<any> {
    return this.masterDataSubject.asObservable();
  }

  getCustomers(): any[] {
    const data = this.getMasterData();
    return data?.customers || [];
  }
}
